import { NIL } from "uuid";
import FormFieldValidation from "../enums/FormFieldValidation";
import IMacroWayFeedback from "../models/macrowayFeedback/IMacroWayFeedback";

export interface IFeedbackValidation {
    department: FormFieldValidation;
    description: FormFieldValidation;
}

export default function validate(feedback: IMacroWayFeedback, setValidation: (validation: IFeedbackValidation) => void) {
    const validation: IFeedbackValidation = {
        department: !!feedback.departmentId && feedback.departmentId !== NIL
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID,
        description: feedback.description.length > 0
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID
    };

    setValidation(validation);

    return Object.values(validation).every(v => v === FormFieldValidation.VALID);
}

export const DefaultValidation: IFeedbackValidation = ({
    department: FormFieldValidation.NOT_VALIDATED,
    description: FormFieldValidation.NOT_VALIDATED
});